module.exports = __webpack_public_path__ + "img/Invasion-CRC_CRLM.9a0a78b4.png";